import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const SIDE_BAR_WIDTH = '276px';

export const useStyles = makeStyles()((theme) => ({
	breadcrumbs: {
		margin: `${theme.spacing.small} 0 ${theme.spacing.medium} 0`,
	},
	accountLayout: {
		display: 'flex',
		flexDirection: 'column',

		[getFromBreakpoint('lg')]: {
			gap: theme.spacing.medium,
			flexDirection: 'row',
		},
	},
	menu: {
		width: '100%',
		boxSizing: 'border-box',

		[getFromBreakpoint('lg')]: {
			marginBottom: theme.spacing.xlarge,
			width: SIDE_BAR_WIDTH,
		},
	},
	pageContent: {
		width: '100%',
		marginBottom: theme.spacing.xlarge,
		marginTop: theme.spacing.large,

		[getFromBreakpoint('lg')]: {
			width: `calc(100% - ${SIDE_BAR_WIDTH} - ${theme.spacing.medium})`,
			marginTop: 0,
		},

		'> h1': {
			marginTop: 0,
			marginBottom: theme.spacing.xlarge,
		},
	},
	linkItem: {
		display: 'block',
		padding: 0,
		width: '100%',
	},
	linkButton: {
		width: '100%',
		display: 'flex',
		gap: theme.spacing.xxsmall,
		padding: theme.spacing.xsmall,
		textDecoration: 'none',
		justifyContent: 'start',
	},
	mobileButton: {
		width: '100%',
		justifyContent: 'space-between',
	},
	mobileButtonText: {
		display: 'inline-flex',
		flexGrow: 1,
	},
}));
